<template>
    <table v-if="product.shop_availability" :class="[tableClass, 'top-aligned-td product-price-table']">
        <tbody>
        <tr class="align-middle">
            <td :style="{ width: useSmallTag ? '5%' : (product.is_special ? '35%' : '45%') }" class="align-middle">
                <div :class="[rawPriceClassName, 'price']">
            <span
                v-if="product.gross_price > 0"
                :class="{
                    'text-nowrap': true,
                    'text-danger': product.is_special,
                    'font-size-14': !useSmallTag,
                    'me-2': !product.is_special
                }"
            >
              {{ $formatter.price(product.totalPrice, product.currency) }}
            </span>
                </div>
            </td>

            <td
                v-if="showNonSpecial && product.is_special && product.non_special_price > product.gross_price"
                class="text-start align-middle"
            >
                <div :class="[specialPriceClassName, 'price']">
            <span
                class="text-muted ms-2 me-2"
                style="text-decoration: line-through;"
                :class="{
                'font-size-18': useSmallTag,
                'font-size-10': !useSmallTag
              }"
            >
              {{ $formatter.price(product.non_special_price, product.currency) }}
            </span>
                </div>
            </td>

            <td class="text-start align-middle">
          <span class="font-size-12 d-inline-block" style="white-space: nowrap;">
            {{ product.vat_status }}
          </span>
            </td>
        </tr>
        </tbody>
    </table>
    <table v-else :class="[tableClass, 'top-aligned-td product-price-table']" style="visibility: hidden;">
        <tbody>
        <tr class="align-middle">
            <td :style="{ width: useSmallTag ? '5%' : (product.is_special ? '35%' : '45%') }" class="align-middle">
                <div :class="[rawPriceClassName, 'price']">
                    <span>&nbsp;</span>
                </div>
            </td>
            <td class="text-start align-middle">
                <span>&nbsp;</span>
            </td>
        </tr>
        </tbody>
    </table>

    <div v-if="shouldShowPremium" class="row mb-2">
        <div class="col">
            <div class="d-block text-uppercase">
                <ProductPremiumLabel :product="product"/>
            </div>
        </div>
    </div>

    <div v-if="shouldShowShippingPrice" class="row mb-2">
        <div class="col text-muted">
            <i18n-t keypath="products.shipping_cost" tag="span">
                <template #price>
          <span v-if="loadingShippingPrice" class="d-inline-block ms-2">
            <LoadingSpinner :is-loading="loadingShippingPrice" />
          </span>
                    <span v-else>
            {{ $formatter.price(shippingPrice, product.currency) }}
          </span>
                </template>
                <template #country>
                    {{ useLocaleStore().ship_country.name }}
                </template>
            </i18n-t>
        </div>
    </div>
</template>

<script setup>
const ProductPremiumLabel = defineAsyncComponent(() => import('~/components/Product/ProductPremiumLabel.vue'))
const LoadingSpinner = defineAsyncComponent(() => import('~/components/LoadingSpinner.vue'))
import { useLocaleStore } from '~/stores/LocaleStore'

const props = defineProps({
    product: { type: Object, required: true },
    tableClass: String,
    useSmallTag: Boolean,
    showNoStock: { type: Boolean, default: true },
    showNonSpecial: { type: Boolean, default: true },
    showPremium: { type: Boolean, default: true },
    showShippingPrice: Boolean,
    showVatInSeparateColumn: { type: Boolean, default: false }
});

const shouldShowShippingPrice = ref(props.showShippingPrice);
const shippingPrice = ref(null);
const loadingShippingPrice = ref(true);

const rawPriceClassName = computed(() =>
    props.useSmallTag ? 'font-size-28' : 'font-size-18'
);
const specialPriceClassName = computed(() =>
    props.useSmallTag ? 'font-size-16' : 'font-size-14'
);
const shouldShowPremium = computed(
    () => props.showPremium && props.product.premium_value !== null
);

async function fetchShippingPrice() {
    if (!props.showShippingPrice) return;
    const response = await getFromClient(`products/${props.product.id}/shipping-price`);
    shippingPrice.value = response.shipping_price;
    loadingShippingPrice.value = false;
    shouldShowShippingPrice.value = shippingPrice.value > 0;
}

onMounted(fetchShippingPrice);
</script>
